import { Component, HostBinding, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogButtonRole, DialogRequestDetail, DialogStyleTokens, TextTokens } from '@app/shared/models/dialog/continue-editing-dialog.model';

type KV = Record<string, string>;

@Component({
  selector: 'app-continue-editing-dialog',
  templateUrl: './continue-editing-dialog.component.html',
  styleUrls: ['./continue-editing-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContinueEditingDialogComponent {
  @HostBinding('class.ep-dialog') host = true;
  cssVars = this.buildCssVarStyle(this.data.styles);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogRequestDetail,
    private readonly dialogRef: MatDialogRef<ContinueEditingDialogComponent, DialogButtonRole | null>
  ) {}

  close(role?: DialogButtonRole): void {
    this.dialogRef.close(role);
  }

  private mapTextTokens(prefix: string, t?: TextTokens): KV {
    if (!t) return {};
    const vars: KV = {};
    if (t.color) vars[`${prefix}-color`] = t.color;
    if (t.align) vars[`${prefix}-align`] = t.align;
    if (t.fontFamily) vars[`${prefix}-font-family`] = t.fontFamily;
    if (t.fontSize) vars[`${prefix}-font-size`] = t.fontSize;
    if (t.fontStyle) vars[`${prefix}-font-style`] = t.fontStyle;
    if (t.fontWeight !== undefined) vars[`${prefix}-font-weight`] = String(t.fontWeight);
    if (t.lineHeight) vars[`${prefix}-line-height`] = t.lineHeight;
    return vars;
  }

  private buildCssVarStyle(tokens?: DialogStyleTokens): KV {
    const out: KV = {};
    if (!tokens) return out;

    Object.assign(out, this.mapTextTokens('--continue-editing-title', tokens.title));
    Object.assign(out, this.mapTextTokens('--continue-editing-desc', tokens.description));

    if (tokens.dialog?.radius) out['--continue-editing-dialog-radius'] = tokens.dialog.radius;
    if (tokens.dialog?.width) out['--continue-editing-dialog-width'] = tokens.dialog.width;

    return out;
  }
}
